import { Checkbox, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material'
import { addDays, subDays } from 'date-fns'
import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Mode } from '../../common/types/calendar'
import { SHOW_ALL_ID, SHOW_ALL_TEXT } from '../../constants/calendar/filterInitValue'
import { useCalendarContext } from '../../context/calendar'
import Ellipsis from '../Utility/Ellipsis'
import Spacer from '../Utility/Spacer'
import { useAuth } from '../../../hooks/use-auth'
import axios from 'axios'

const CalendarHeader: FC = () => {
  const auth = useAuth();
  const [title, setTitle] = React.useState('');

  useEffect(() => {
    axios.get('/v0/account/factories', {
      headers: auth.authorizationHeader,
      params: { factory_id: auth.factoryId }
    })
      .then((res) => {
        setTitle(res.data[0].name);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const { columns, date, mode, setDate, setFiltered, setMode } = useCalendarContext()
  const [filterSelectedValue, setFilterSelectedValue] = useState<string[]>([SHOW_ALL_ID])
  const [columnsCount, setColumnsCount] = useState<number>(0)

  useEffect(() => {
    setColumnsCount(columns.length)
  }, [columns])

  useEffect(() => {
    setFiltered(columns)
  }, [columnsCount])

  return (
    <CalendarHeaderWrapper data-print-invisible={true}>
      <CalendarHeaderTitle>
        <Ellipsis>{title}</Ellipsis>
      </CalendarHeaderTitle>
      <CalendarHeaderCenter>
        <IconWrapper
          onClick={() => {
            setDate(subDays(date, 7))
          }}
        >
          <svg
            width="9"
            height="12"
            viewBox="0 0 9 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.74853 0.351588C7.9735 0.576621 8.09988 0.881791 8.09988 1.19999C8.09988 1.51818 7.9735 1.82335 7.74853 2.04839L3.79693 5.99999L7.74853 9.95159C7.96712 10.1779 8.08808 10.481 8.08534 10.7957C8.08261 11.1103 7.95641 11.4113 7.73392 11.6338C7.51143 11.8563 7.21045 11.9825 6.89582 11.9852C6.58118 11.9879 6.27806 11.867 6.05173 11.6484L1.25173 6.84839C1.02677 6.62335 0.900391 6.31818 0.900391 5.99999C0.900391 5.68179 1.02677 5.37662 1.25173 5.15159L6.05173 0.351588C6.27677 0.126623 6.58194 0.000244141 6.90013 0.000244141C7.21833 0.000244141 7.5235 0.126623 7.74853 0.351588V0.351588Z"
              fill="#373737"
            />
          </svg>
        </IconWrapper>
        <Spacer width={40} />
        前週
        <Spacer width={40} />
        翌週
        <Spacer width={40} />
        <IconWrapper
          onClick={() => {
            setDate(addDays(date, 7))
          }}
        >
          <svg
            width="9"
            height="12"
            viewBox="0 0 9 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.25173 11.6484C1.02677 11.4234 0.900391 11.1182 0.900391 10.8C0.900391 10.4818 1.02677 10.1767 1.25173 9.95163L5.20333 6.00003L1.25173 2.04842C1.03314 1.8221 0.912191 1.51898 0.914925 1.20434C0.917659 0.889707 1.04386 0.588733 1.26635 0.366243C1.48884 0.143753 1.78982 0.01755 2.10445 0.0148159C2.41909 0.0120818 2.72221 0.133036 2.94853 0.351625L7.74853 5.15163C7.9735 5.37666 8.09988 5.68183 8.09988 6.00003C8.09988 6.31822 7.9735 6.62339 7.74853 6.84842L2.94853 11.6484C2.7235 11.8734 2.41833 11.9998 2.10013 11.9998C1.78194 11.9998 1.47677 11.8734 1.25173 11.6484Z"
              fill="#373737"
            />
          </svg>
        </IconWrapper>
      </CalendarHeaderCenter>
      <CalendarHeaderRight>
        <Select
          style={{ height: '29px', marginLeft: '18px', width: '100px' }}
          multiple
          value={filterSelectedValue}
          onChange={({ target }) => {
            if (typeof target.value === 'string') {
              return
            }
            const oldValue = filterSelectedValue
            const newValue = target.value.sort()

            if (newValue.length === 0) {
              setFilterSelectedValue([SHOW_ALL_ID])
              setFiltered(columns)
            } else if (!oldValue.includes(SHOW_ALL_ID) && newValue.includes(SHOW_ALL_ID)) {
              setFilterSelectedValue([SHOW_ALL_ID])
              setFiltered(columns)
            } else if (oldValue.includes(SHOW_ALL_ID)) {
              setFilterSelectedValue(newValue.filter((value) => value !== SHOW_ALL_ID))
              setFiltered(
                columns.filter(
                  (column) => column.id !== SHOW_ALL_ID && newValue.includes(column.id)
                )
              )
            } else {
              setFilterSelectedValue(newValue)
              setFiltered(columns.filter((column) => newValue.includes(column.id)))
            }
          }}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected[0] === SHOW_ALL_ID) {
              return SHOW_ALL_TEXT
            }
            return selected.join(', ')
          }}
        >
          <MenuItem value={SHOW_ALL_ID}>
            <Checkbox checked={filterSelectedValue.includes(SHOW_ALL_ID)} />
            <ListItemText primary={SHOW_ALL_TEXT} />
          </MenuItem>
          {columns.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              <Checkbox checked={filterSelectedValue.includes(item.id)} />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
        <Select
          style={{ height: '29px', marginLeft: '10px', width: '100px' }}
          value={mode}
          onChange={({ target }) => setMode(target.value as Mode)}
          renderValue={(selected) => {
            if (selected === 'date') {
              return '日'
            } else if (selected === 'week') {
              return '週'
            }
          }}
        >
          <MenuItem value={'date'}>
            <Checkbox checked={mode === 'date'} />
            <ListItemText primary={'日'} />
          </MenuItem>
          <MenuItem value={'week'}>
            <Checkbox checked={mode === 'week'} />
            <ListItemText primary={'週'} />
          </MenuItem>
        </Select>
      </CalendarHeaderRight>
    </CalendarHeaderWrapper>
  )
}

export default CalendarHeader

const CalendarHeaderWrapper = styled.div`
  box-sizing: content-box !important;
  min-height: 54px;
  min-width: 0;
  padding: 19px;
  display: flex;
  justify-content: space-between;
`

const CalendarHeaderTitle = styled.div`
  font-family: Noto Sans JP;
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.04em;
  text-align: left;
  width: 40%;
  min-width: 0;
`

const CalendarHeaderCenter = styled.div`
  min-width: 350px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: 0em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
`

const CalendarHeaderRight = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 240px;
  width: 20%;
`

const IconWrapper = styled.span`
  width: 24px;
  height: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
